import { Component } from '@angular/core';

@Component({
  selector: 'app-loader',
  template: '',
})
export class LoaderComponent {}
